<template>
  <div id="data-list-list-view" class="data-list-container">

    <div v-if="initProgress" class="w-100 mt-5 mb-5">
      <vs-progress indeterminate color="primary"></vs-progress>
    </div>

    <vs-prompt title="Exportar a Excel" class="export-options" @cancle="clearFields" @accept="exportToExcel"
               accept-text="Exportar" cancel-text="Cancelar" @close="clearFields" :active.sync="activePrompt">
      <vs-input v-model="fileName" placeholder="Ingresa el nombre del archivo..." class="w-full"/>
      <v-select v-model="selectedFormat" :options="formats" class="my-4"/>
      <div class="flex">
        <span class="mr-4">Auto ajustar columna:</span>
        <vs-switch v-model="cellAutoWidth">Auto ajustar columna</vs-switch>
      </div>
    </vs-prompt>

    <new :providers="providers" :brands="brands" :isSidebarActive="newSidebar"
         @closeSidebar="toggleNewSidebar"/>

    <update :providers="providers" :brands="brands" :isSidebarActive="updateSidebar"
            @closeSidebar="toggleEditSideBar" :data="sidebarData"/>

    <vs-table v-model="selected" ref="table" pagination :max-items="itemsPerPage" search
              :data="inputs">
      <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center data-list-btn-container">
          <!-- Action - dropnow -->
          <vs-dropdown vs-trigger-click class="dd-actions cursor-pointer mr-4 mb-4">
            <div
                class="p-4 shadow-drop rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-center text-lg font-medium w-32 w-full">
              <span class="mr-2">Acciones</span>
              <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
            </div>
            <vs-dropdown-menu>
              <vs-dropdown-item @click="ediData(selected)">
                            <span class="flex items-center">
                              <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" class="mr-2"/>
                              <span>Editar</span>
                            </span>
              </vs-dropdown-item>
              <vs-dropdown-item @click="activePrompt=true">
                            <span class="flex items-center">
                              <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="mr-2"/>
                              <span>Exportar a excel</span>
                            </span>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <!-- Add new -->
          <div
              class="btn-add-new p-3 mb-4 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-base text-primary border border-solid border-primary"
              @click="addNewData">
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4"/>
            <span class="ml-2 text-base text-primary">Agregar</span>
          </div>
        </div>
        <!-- Items per page -->
        <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4 items-per-page-handler">
          <div
              class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
            <span class="mr-2">{{
                currentPage * itemsPerPage - (itemsPerPage - 1)
              }} - {{ inputs.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : inputs.length }} de {{
                queriedItems
              }}</span>
            <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4"/>
          </div>
          <vs-dropdown-menu>

            <vs-dropdown-item @click="itemsPerPage=10">
              <span>10</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=20">
              <span>20</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=30">
              <span>30</span>
            </vs-dropdown-item>
            <vs-dropdown-item @click="itemsPerPage=40">
              <span>40</span>
            </vs-dropdown-item>
          </vs-dropdown-menu>
        </vs-dropdown>
      </div>

      <template slot="thead">
        <vs-th sort-key="sku">Nro. de Orden</vs-th>
        <vs-th sort-key="sku">Fecha de Recepción</vs-th>
        <vs-th sort-key="guide">Nro. de Guía</vs-th>
        <vs-th sort-key="provider">Proveedor</vs-th>
        <vs-th sort-key="state">Estado</vs-th>
        <vs-th>Acciones</vs-th>
      </template>

      <template slot-scope="{data}">
        <tbody>
        <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">

          <vs-td>
            <p class="font-medium">{{ tr.number }}</p>
          </vs-td>

          <vs-td>
            <p class="font-medium">{{ tr.receptionDate | date(true) }}</p>
          </vs-td>

          <vs-td>
            <p class="font-medium">{{ tr.guide }}</p>
          </vs-td>

          <vs-td>
            <p class="font-medium">{{ tr.provider.name }}</p>
          </vs-td>

          <vs-td>
            <vs-chip :color="getOrderStatusColor(tr.stateText.value)" class="product-order-status">
              {{ tr.stateText.label | title }}
            </vs-chip>
          </vs-td>

          <vs-td class="whitespace-no-wrap">
            <feather-icon v-if="tr.stateText.value==='draft'" class="ml-2" icon="EditIcon"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="ediData(tr)"/>
            <feather-icon v-if="tr.stateText.value==='draft'" class="ml-2" icon="TrashIcon"
                          svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="deleteData(tr)"/>
            <feather-icon class="ml-2" icon="PrinterIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current"
                          @click.stop="printGo(tr)"/>
          </vs-td>
        </vs-tr>
        </tbody>
      </template>
    </vs-table>
  </div>
</template>

<script>
import New from './New'
import Update from './Update'
import vSelect from 'vue-select'

const firebase = require("firebase")
// Required for side-effects
require("firebase/firestore")
let db = firebase.firestore()
import print from "print-js"

import json from '../../assets/json/inputs.json'
import json2 from '../../assets/json/input_products.json'

export default {
  name: 'ListInputs',
  components: {
    New,
    Update,
    vSelect
  },
  data() {
    return {
      selected: null,
      itemsPerPage: 10,
      isMounted: false,
      inputsPre: [],
      initProgress: false,
      brands: [],
      providers: [],
      inputsJson: json,
      inputProductsJson: json2,

      // Data Sidebar
      newSidebar: false,
      updateSidebar: false,
      sidebarData: {},

      // Export
      fileName: '',
      formats: ['xlsx'],
      cellAutoWidth: true,
      selectedFormat: 'xlsx',
      headerTitle: ['Nro. de orden', 'Fecha de recepción', 'Nro. de Guía', 'Proveedor'],
      headerVal: ['number', 'receiptDate', 'guide', 'provider'],
      activePrompt: false
    }
  },
  computed: {
    inputs: {
      get() {
        return this.$store.state.inputs.inputs
      }
    },
    currentPage() {
      if (this.isMounted) {
        return this.$refs.table.currentx
      }
      return 0
    },
    queriedItems() {
      return this.$refs.table ? this.$refs.table.queriedResults.length : this.inputs.length
    }
  },
  async created() {
    try {
      this.initProgress = true
      await this.loadInputs()
      await this.loadBrands()
      await this.loadProviders()
      this.initProgress = false
      this.$store.dispatch('inputs/fetchInputs', {inputs: this.inputsPre})
    } catch (e) {
      this.$vs.notify({
        color: 'warning',
        title: '¡Oh no!',
        text: 'Hubo un error.'
      })
    }
  },
  mounted() {
    this.isMounted = true
  },
  methods: {
    addNewData() {
      this.sidebarData = {}
      this.newSidebar = true
    },
    ediData(data) {
      if (data && data.stateText.value === 'draft') {
        this.sidebarData = data
        this.toggleEditSideBar(true)
      }
    },
    async deleteData(input) {
      try {
        await db.collection('inputs').doc(input.id).delete()
        await this.$store.dispatch('inputs/deleteInput', input)
        this.$vs.notify({
          color: 'success',
          title: 'Orden de ingreso',
          text: 'Eliminada correctamente.'
        })
      } catch (e) {
        console.log(e)
        this.$vs.notify({
          color: 'warning',
          title: '¡Oh no!',
          text: 'Hubo un error.'
        })
      }
    },
    toggleNewSidebar(val = false) {
      this.newSidebar = val
    },
    toggleEditSideBar(val = false) {
      this.updateSidebar = val
    },
    loadInputs() {
      return new Promise((resolve, rejected) => {
        db.collection("inputs").orderBy('createdAt', 'desc').get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let input = {
              id: doc.id,
              ...doc.data(),
              receptionDate: doc.data().receptionDate.toDate(),
              createdAt: doc.data().createdAt.toDate()
            }
            this.inputsPre.push(input)
          })
          resolve(true)
        }).catch((e) => {
          rejected(e)
        })
      })
    },
    loadBrands() {
      return new Promise((resolve, rejected) => {
        db.collection("brands").where('state', '==', true).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let obj = {
              id: doc.id,
              ...doc.data()
            }
            this.brands.push(obj)
          })
          resolve(true)
        }).catch((e) => {
          rejected(e)
        })
      })
    },
    loadProviders() {
      return new Promise((resolve, rejected) => {
        db.collection("providers").where('state', '==', true).get().then((querySnapshot) => {
          querySnapshot.forEach((doc) => {
            let obj = {
              id: doc.id,
              ...doc.data()
            }
            this.providers.push(obj)
          })
          resolve(true)
        }).catch((e) => {
          rejected(e)
        })
      })
    },
    filterData() {
      this.filter = !this.filter
    },
    getOrderStatusColor(status) {
      if (status === 'draft') return 'danger'
      return 'success'
    },
    async importInputs() {
      this.initProgress = true
      const batch = db.batch()
      this.inputsJson.forEach((input, index) => {
        if (index > 0 && index <= 250) {
          const docRef = db.collection('inputs').doc(input.id + "")
          batch.set(docRef, {
            number: input.code,
            guide: input.guide,
            receptionDate: new Date(input.receipt_date),
            vehicle: input.vehicle,
            certificate: input.vehicle_ci,
            license: input.driver_license,
            stateText: this.getState(input.state),
            provider: {
              id: input.providerId,
              name: input.providerName,
              typeDocument: {
                label: input.providerTD,
                value: input.providerTD === 'DNI' ? 'dni' : 'ruc'
              },
              document: input.providerDocument
            },
            state: true,
            createdAt: firebase.firestore.FieldValue.serverTimestamp()
          })
        }
      })
      await batch.commit()
      this.initProgress = false
    },
    async importProducts() {
      this.initProgress = true
      const products = []
      const batch = db.batch()
      this.inputProductsJson.forEach((p) => {
        const obj = {
          inputId: p.inputId + "",
          id: p.productId + "",
          name: p.productName,
          sku: p.productSku,
          category: {
            id: p.categoryId,
            name: p.categoryName
          },
          brand: {
            id: p.brandId,
            name: p.brandName
          },
          quantity: p.quantity
        }
        products.push(obj)
      })
      this.inputsPre.forEach((i) => {
        i.products = products.filter((p) => p.inputId === i.id)
        i.productsId = []
      })
      this.inputsPre.forEach((i) => {
        i.products.forEach((p) => {
          i.productsId.push(p.id + "")
        })
        delete i.createdAt
        delete i.receptionDate
        const docRef = db.collection('inputs').doc(i.id + "")
        batch.update(docRef, {
          ...i
        })
      })
      await batch.commit()
      this.initProgress = false
    },
    getState(label) {
      const states = [
        {label: 'Borrador', value: 'draft'},
        {label: 'Publicada', value: 'published'},
      ]
      return states.find((s) => s.label === label)
    },
    printGo(input) {
      const products = []
      input.products.forEach((p) => {
        products.push({
          sku: p.sku,
          name: p.name,
          brand: p.brand.name,
          category: p.category.name,
          quantity: p.quantity
        })
      })
      print({
        printable: products,
        type: 'json',
        properties: [
          {field: 'sku', displayName: 'Código'},
          {field: 'name', displayName: 'Nombre'},
          {field: 'brand', displayName: 'Marca'},
          {field: 'category', displayName: 'Categoría'},
          {field: 'quantity', displayName: 'Cantidad'}
        ],
        header: `<h1 class="custom-h1">Orden de ingreso</h1><p>#${input.number}<br>Fecha de recepción: ${this.$options.filters.date(input.receptionDate, true)}</p><br><h2 class="custom-h2">Punto Estratégico</h2><p>20553965072 <br>Calle Costa Azul #334 Chorrillos</p><br><strong>Proveedor</strong><br>${input.provider.name}<br>${input.provider.document}<br>Nro. de guía: ${input.guide}<br><br><strong>Unidad de transporte/Conductor</strong><br>Vehiculo Marca y Placa N°: ${input.vehicle}<br>Licencia de conducir: ${input.license}<br>Certificado de inscripción: ${input.certificate}</p>`,
        style: '.custom-h2 {margin-bottom: 1rem} .custom-h1 {font-size:30px; margin-bottom: 1rem}'
      })
    },
    clearFields() {
      this.filename = ''
      this.cellAutoWidth = true
      this.selectedFormat = 'xlsx'
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => {
        // Add col name which needs to be translated
        // if (j === 'timestamp') {
        //   return parseTime(v[j])
        // } else {
        //   return v[j]
        // }

        return v[j]
      }))
    },
    exportToExcel() {
      import('@/vendor/Export2Excel').then(excel => {
        const list = []
        this.inputsPre.forEach((input) => {
          let obj = {
            number: input.number,
            receiptDate: input.receptionDate,
            guide: input.guide,
            provider: input.provider.name
          }
          list.push(obj)
        })
        const data = this.formatJson(this.headerVal, list)
        excel.export_json_to_excel({
          header: this.headerTitle,
          data,
          filename: this.fileName,
          autoWidth: this.cellAutoWidth,
          bookType: this.selectedFormat
        })
        this.clearFields()
      })
    }
  }
}
</script>

<style lang="scss">
#data-list-list-view {
  .vs-con-table {

    /*
      Below media-queries is fix for responsiveness of action buttons
      Note: If you change action buttons or layout of this page, Please remove below style
    */
    @media (max-width: 689px) {
      .vs-table--search {
        margin-left: 0;
        max-width: unset;
        width: 100%;

        .vs-table--search-input {
          width: 100%;
        }
      }
    }

    @media (max-width: 461px) {
      .items-per-page-handler {
        display: none;
      }
    }

    @media (max-width: 341px) {
      .data-list-btn-container {
        width: 100%;

        .dd-actions,
        .btn-add-new {
          width: 100%;
          margin-right: 0 !important;
        }
      }
    }

    .product-name {
      max-width: 23rem;
    }

    .vs-table--header {
      display: flex;
      flex-wrap: wrap;
      margin-left: 1.5rem;
      margin-right: 1.5rem;

      > span {
        display: flex;
        flex-grow: 1;
      }

      .vs-table--search {
        padding-top: 0;

        .vs-table--search-input {
          padding: 0.9rem 2.5rem;
          font-size: 1rem;

          & + i {
            left: 1rem;
          }

          &:focus + i {
            left: 1rem;
          }
        }
      }
    }

    .vs-table {
      border-collapse: separate;
      border-spacing: 0 1.3rem;
      padding: 0 1rem;

      tr {
        box-shadow: 0 4px 20px 0 rgba(0, 0, 0, .05);

        td {
          padding: 20px;

          &:first-child {
            border-top-left-radius: .5rem;
            border-bottom-left-radius: .5rem;
          }

          &:last-child {
            border-top-right-radius: .5rem;
            border-bottom-right-radius: .5rem;
          }
        }

        td.td-check {
          padding: 20px !important;
        }
      }
    }

    .vs-table--thead {
      th {
        padding-top: 0;
        padding-bottom: 0;

        .vs-table-text {
          text-transform: uppercase;
          font-weight: 600;
        }
      }

      th.td-check {
        padding: 0 15px !important;
      }

      tr {
        background: none;
        box-shadow: none;
      }
    }

    .vs-table--pagination {
      justify-content: center;
    }
  }
}
</style>
